// Pure helpers for the demo access code screen.

export const DEMO_TOKEN_STORAGE_KEY = 'housingfirst.demoAccessToken'

const DEMO_CODE_LENGTH = 6

// Keeps digits only, so a code pasted with spaces still works.
export const normalizeDemoCode = (raw: string): string => raw.replace(/\D/g, '').slice(0, DEMO_CODE_LENGTH)

export const isDemoCodeComplete = (code: string): boolean => code.length === DEMO_CODE_LENGTH

export type DemoAccessFailure = 'invalid' | 'unavailable'

// The function answers 401 for a wrong code or token. Anything else, including
// no answer at all, means it could not decide.
export const demoAccessFailure = (status: number | undefined): DemoAccessFailure =>
    status === 401 ? 'invalid' : 'unavailable'

// A FunctionsHttpError or FunctionsRelayError carries the Response in `context`.
// A FunctionsFetchError carries a TypeError there, so it has no status.
export const errorStatus = (error: unknown): number | undefined => {
    if (typeof error !== 'object' || error === null) return undefined
    const context = (error as { context?: unknown }).context
    if (typeof context !== 'object' || context === null) return undefined
    const status = (context as { status?: unknown }).status
    return typeof status === 'number' ? status : undefined
}

// A 2xx answer is only trusted when it has the expected shape. Anything else
// means the function could not decide, so the gate stays closed.
export const isTokenCheck = (value: unknown): value is { expiresAt: number } =>
    typeof value === 'object' &&
    value !== null &&
    typeof (value as { expiresAt?: unknown }).expiresAt === 'number' &&
    Number.isFinite((value as { expiresAt: number }).expiresAt)

export const isIssuedToken = (value: unknown): value is { token: string; expiresAt: number } => {
    if (!isTokenCheck(value)) return false
    const token = (value as { token?: unknown }).token
    return typeof token === 'string' && token.length > 0
}

export const DEMO_ACCESS_MESSAGES: Record<DemoAccessFailure, string> = {
    invalid: 'Code incorrect.',
    unavailable: 'Impossible de vérifier le code. Réessayez.',
}
